import {
  iconPropTypes,
  iconDefaultProps,
  iconCommonProps
} from '../propTypes';

const PrevTrackRounded = ({ className, color }) => (
  <svg
    { ...iconCommonProps }
    className={ className }
    fill='none'
    viewBox='0 0 49 25'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M25.316 10.368 44.96.318C46.556-.5 49 .292 49 2.311v20.097c0 1.811-2.271 2.903-4.04 1.995L25.316 14.358c-1.752-.894-1.758-3.096 0-3.99Z'
      fill={ color }
    />
    <path
      d='M7.316 10.368 26.96.318C28.556-.5 31 .292 31 2.311v20.097c0 1.811-2.271 2.903-4.04 1.995L7.316 14.358c-1.752-.894-1.758-3.096 0-3.99Z'
      fill={ color }
    />
    <rect
      fill={ color }
      height={ 24.727 }
      rx={ 3 }
      width={ 6.182 }
    />
  </svg>
);

PrevTrackRounded.propTypes = { ...iconPropTypes };

PrevTrackRounded.defaultProps = { ...iconDefaultProps };

export default PrevTrackRounded;